module.exports = __webpack_public_path__ + "static/media/question_countdown_v1.b966a400.gif";